import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { offerItems, images } from '../data/content';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
export function Offer() {
  return <section id="offer" className="bg-cream px-4 py-16" aria-labelledby="offer-title" data-id="element-191" data-mp="1hoforvb7bd7j">
      <div className="mx-auto max-w-xl" data-id="element-192" data-mp="1hqs5641b9fih">
        <p className="text-center text-sm font-bold uppercase tracking-widest text-gold-dark" data-id="element-193" data-mp="ty1wc3opfccf">Special launch offer</p>
        <h2 id="offer-title" className="mt-3 text-center font-serif text-[2rem] font-bold leading-tight text-ink sm:text-5xl" data-id="element-194" data-mp="p11yuh5x7hwx">
          Here’s everything you’ll receive today
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border-2 border-gold bg-white shadow-[0_30px_60px_-30px_rgba(11,11,12,0.45)]" data-id="element-195" data-mp="ywwm5pl3a161">
          <div className="bg-ink px-5 py-3 text-center text-sm font-extrabold uppercase tracking-wider text-gold" data-id="element-196" data-mp="2feaog8slm00q">
            Launch pricing — today only
          </div>
          <div className="p-5 sm:p-8" data-id="element-197" data-mp="pjfkcavzonj6">
            <img src={images.mockup} alt="" className="mx-auto w-full" data-id="element-198" data-mp="pml6pid8hbb7" />

            <ul className="mt-4 divide-y divide-ink/10" data-id="element-199" data-mp="uhh1urdroesj">
              {offerItems.map(item => <li key={item.label} className="flex items-start justify-between gap-3 py-3" data-id="element-200" data-mp="zj6da84wiuh5">
                  <span className="flex gap-2.5 text-[15px] font-medium leading-snug text-ink" data-id="element-201" data-mp="13j74ktd3n05m">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-202" data-mp="6vahr6r2j8ly" />
                    {item.label}
                  </span>
                  <span className="shrink-0 text-sm font-semibold text-muted line-through" data-id="element-203" data-mp="ftw319nxd1qf">${item.value}</span>
                </li>)}
            </ul>

            <div className="mt-6 text-center" data-id="element-204" data-mp="kmyxdk0j0f7o">
              <p className="text-lg text-muted" data-id="element-205" data-mp="3k7kqaqvpzild">
                Total value: <span className="font-bold text-red-600 line-through" data-id="element-206" data-mp="3oa7kgyfv5flq">$244</span>
              </p>
              <p className="mt-2 text-sm font-bold uppercase tracking-wider text-ink" data-id="element-207" data-mp="vfqw9zv6z8r5">Today you get everything for only</p>
              <p className="mt-1 font-serif text-[5.5rem] font-bold leading-none text-ink" data-id="element-208" data-mp="qhfn7rcq129z">
                <span className="align-top text-4xl" data-id="element-209" data-mp="1561zfk71xdwz">$</span>27
              </p>
              <p className="mt-3 text-[15px] font-medium text-muted" data-id="element-210" data-mp="106h0h9rvt5k9">
                One-time payment · Lifetime digital access · No monthly subscription · Immediate access
              </p>
            </div>

            <div className="mt-5 flex items-start gap-3 rounded-xl bg-cream-deep p-4" data-id="element-211" data-mp="7i1pcybvf7e7">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-212" data-mp="lhkxhr4omiqi" />
              <p className="text-sm leading-snug text-ink" data-id="element-213" data-mp="hfzb9f69cs3n">
                <strong data-id="element-214" data-mp="heeinv3i7j8f">Automatic currency conversion:</strong> the price is automatically adjusted to your country’s
                local currency at checkout.
              </p>
            </div>

            <div className="mt-6" data-id="element-215" data-mp="1sul8i1xxduq4">
              <ScarcityBar data-id="element-216" data-mp="1sxhac1cw93ju" />
            </div>

            <div className="mt-6" data-id="element-217" data-mp="20dm3fyunug1v">
              <CTAButton label="Get Sculptor’s Operating Blueprint™" data-id="element-218" data-mp="20gqixsdksy7u" />
              <p className="mt-3 text-center text-sm text-muted" data-id="element-219" data-mp="25ei7ccf0i27a">
                One-time payment of $27 · Instant digital access · 7-day guarantee
              </p>
            </div>

            <div className="mt-8 border-t border-ink/10 pt-7" data-id="element-220" data-mp="1vglzpula9pdx">
              <Countdown data-id="element-221" data-mp="2j555a2cy7o2b" />
            </div>
          </div>
        </div>

        <p className="mt-8 text-center text-lg leading-relaxed text-muted" data-id="element-222" data-mp="2j787rlvaf9nx">
          <strong className="text-ink" data-id="element-223" data-mp="2o2x1h8kmlwcb">For less than the cost of a typical dinner…</strong> you get an organized professional
          reference system to structure your rhinoplasty case analysis, planning, preparation, and review.
        </p>
      </div>
    </section>;
}